import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Img from "@insite/mobius/Img";
import Typography from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import { getLink, useGetLinks } from "@insite/client-framework/Store/Links/LinksSelectors";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { connect } from "react-redux";
import Link from "@insite/mobius/Link";

const mapStateToProps = (state: ApplicationState) => ({
    state
});
interface IndustryItem {
    image: string;
    label: string;
    buttonLink: LinkFieldValue;
}
type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

interface PropsComponent extends Props {
    fields: {
        industries: IndustryItem[];
    };
}

const styles: {
    iconGrid: InjectableCss;
    iconItem: InjectableCss;
    iconImage: InjectableCss;
    iconLabel: InjectableCss;
} = {
    iconGrid: {
        css: css`
            gap: 3px !important;
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            max-width: 1000px;
            background: transparent;
            padding: 0;
        `,
    },
    iconItem: {
        css: css`
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 100px;
            text-align: center;
            margin-bottom: 20px;
        `,
    },
    iconImage: {
        css: css`
            width: 70px;
            height: 70px;
            margin-bottom: 2px;
            object-fit: contain;
        `,
    },
    iconLabel: {
        css: css`
            font-size: 9px;
            line-height: normal;
            color: #005bac;
            text-transform: uppercase;
            font-weight: 600;
            font-family: Barlow-Regular;
        `,
    },
};

export const IndustriesServedGridTest: React.FC<PropsComponent> = ({ fields, state }) => {
   
    let industries = (fields.industries || []).map(item =>{
        let links;
        if((item as any).fields.buttonLink){
            links = getLink(state, (item as any).fields.buttonLink);
        }
        return (item as any).fields ? {...(item as any).fields,links} : {...item,links}
    }    
);
    
    return (
        <StyledWrapper {...styles.iconGrid}>
            {industries.map((industry, idx) =>{
                return (
                <Link
                    href={industry?.links?.url || ""}
                    style={{ cursor: industry?.links?.url ? "pointer" : "default" }}
                >
                    <StyledWrapper {...styles.iconItem} key={idx}>
                        <Img
                            src={industry.image}
                            alt={industry.label}
                            {...styles.iconImage}
                        />
                        <Typography {...styles.iconLabel}>{industry.label}</Typography>
                    </StyledWrapper>
                </Link>
            )})}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(IndustriesServedGridTest),
    definition: {
        group: "Basic",
        icon: "image",
        displayName: "Industries Service Grid",
        fieldDefinitions: [
            {
                name: "industries",
                displayName: "Industries",
                editorTemplate: "ListField",
                fieldType: "Contextual",
                getDisplay: ({ fields: { label } }) => label || "Service",
                fieldDefinitions: [ 
                    {
                        name: "image",
                        displayName: "Image",
                        editorTemplate: "ImagePickerField",
                        defaultValue: "",
                    },
                    {
                        name: "label",
                        displayName: "Label",
                        editorTemplate: "TextField",
                        defaultValue: "",
                    },
                    {
                        name: "buttonLink",
                        displayName: "Button Link",
                        editorTemplate: "LinkField",
                        defaultValue: { type: "Page", value: "" },
                    },
                ],
                defaultValue: [],
            },
],
    },
};

export default widgetModule;